export const getSelectedGroup = (timeoutMs = 5000) => {
  try {
    const directGroup = window?.parent?.app?.selectedGroup
    if (directGroup) {
      return Promise.resolve(directGroup)
    }
  } catch (error) {}
  return new Promise((resolve) => {
    const handler = (event) => {
      if (event.data?.type === "GROUP_SELECTED_RESPONSE") {
        window.removeEventListener("message", handler)
        resolve(event.data?.group || null)
      }
    }

    window.addEventListener("message", handler)
    window.parent.postMessage({ type: "GROUP_SELECTED_REQUEST" }, "*")

    setTimeout(() => {
      window.removeEventListener("message", handler)
      resolve(null)
    }, timeoutMs)
  })
}

export const getAccount = (timeoutMs = 5000) => {
  try {
    const directUser = window?.parent?.app?.user
    if (directUser) {
      return Promise.resolve(directUser)
    }
  } catch (error) {}
  return new Promise((resolve) => {
    const handler = (event) => {
      if (event.data?.type === "ACCOUNT_RESPONSE") {
        window.removeEventListener("message", handler)
        resolve(event.data?.user || null)
      }
    }

    window.addEventListener("message", handler)
    window.parent.postMessage({ type: "ACCOUNT_REQUEST" }, "*")

    setTimeout(() => {
      window.removeEventListener("message", handler)
      resolve(null)
    }, timeoutMs)
  })
}
